// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MGYYT","cardsContainer":"Home_cardsContainer__xmAt5","notFound":"Home_notFound__tdcKz","shake":"Home_shake__QAk++"};